<ion-content class="signUp-content">
  <div class="signup-wrap flex-container"  lang="en">
    <div>
      <ion-fab vertical="top" horizontal="start" slot="fixed">
        <ion-icon name="arrow-back" class="close-fab" [routerLink]="['/welcome']" routerDirection="back"></ion-icon>
      </ion-fab>
      <dl>
        <div class="ion-text-center">
          <dt>
            <div class="signup-text">
              <h3 class="heading">{{'signup.Create' | translate}}<br />{{'signup.free account' | translate}}</h3>
            </div>
          </dt>
        </div>
      </dl>
    </div>

    <div>
      <form [formGroup]="signupForm" (ngSubmit)="onSignupFormSubmit()" class="signup-form-size">
        <div class="main">
          <div class="avatarContainer">
            <!-- For PWA -->
            <ion-avatar class="avatar-center" (click)="selectImage()">
              @if (!(uploading$ | async) && !(userProfilePic$ | async)) {
                <ion-icon name="add-circle"
                class="addImagePosition"></ion-icon>
              }
              @if ((uploading$ | async)) {
                <div class="spinnerContainer">
                  <mat-progress-spinner class="custom-spinner" mode="determinate" [value]="progressValue" diameter="40">
                  </mat-progress-spinner>
                </div>
              }
              @if ((showInitials$ | async) && !(userProfilePic$ | async) && !(uploading$ | async)) {
                <div
                  class="circle-with-text">
                  <span>{{initialText | uppercase }}</span>
                </div>
              }
              @if (!(userProfilePic$ | async) && !(showInitials$ | async) && !(uploading$ | async)) {
                <ion-img
                  id="userProfilePicDefault" src="assets/images/usericon_profile_signup.svg" class="userimgDefault"
                alt="user icon profile signup"></ion-img>
              }
              @if ((userProfilePic$ | async) && !(uploading$ | async)) {
                <ion-img id="userProfilePic"
                [src]="imagePath$ | async" class="animationClass"></ion-img>
              }
            </ion-avatar>
            <input type="file" #selectBtn id="selectBtn" name="selectBtn" class="hide-content"
              accept="image/x-png,image/jpeg,image/gif" (change)="imageUpload($event.target.files)" />
            </div>

            <div class="signup-form">
              <ion-item
                [ngClass]="signupForm.get('firstName').dirty && signupForm.get('firstName').invalid ? 'invalid-field': ''">
                <ion-input placeholder="{{'signup.First_name' | translate}}" formControlName="firstName" type="text"
                  class="signupfield" maxlength="15" accesskey="f" aria-labelledby="ion-input-0-lbl"
                  (keypress)="onlyAlpha($event)" autocomplete="on" (input)="autoFill($event,'firstName')">
                </ion-input>
              </ion-item>
              @if (signupForm.get('firstName').dirty && signupForm.get('firstName').invalid && signupForm.get('firstName').value?.length > 0 && signupForm.get('firstName').value?.length < 3) {
                <div class="errorContainer"
                  >
                  <ion-icon name="warning" class="icon"></ion-icon>
                  <span class="text">{{'signup.valid first name' | translate}}</span>
                </div>
              }
              @if (signupForm.get('firstName').dirty && signupForm.get('firstName').value?.length === 0 ? 'invalid-field': '') {
                <div class="errorContainer"
                  >
                  <ion-icon name="warning" class="icon"></ion-icon>
                  <span class="text">{{'signup.enter first' | translate}}</span>
                </div>
              }

              <ion-item
                [ngClass]="signupForm.get('lastName').dirty && signupForm.get('lastName').invalid  ? 'invalid-field': ''">
                <ion-input placeholder="{{'signup.Last_name' | translate}}" formControlName="lastName" type="text"
                  class="signupfield" maxlength="15" (keypress)="onlyAlpha($event)" aria-labelledby="ion-input-1-lbl"
                  autocomplete="on" (input)="autoFill($event,'lastName')">
                </ion-input>
              </ion-item>

              @if (signupForm.get('lastName').dirty && signupForm.get('lastName').invalid && signupForm.get('lastName').value?.length > 0 && signupForm.get('lastName').value?.length < 3) {
                <div class="errorContainer"
                  >
                  <ion-icon name="warning" class="icon"></ion-icon>
                  <span class="text">{{'signup.valid last name' | translate}}</span>
                </div>
              }
              @if (signupForm.get('lastName').dirty && signupForm.get('lastName').value?.length === 0 ? 'invalid-field': '') {
                <div class="errorContainer"
                  >
                  <ion-icon name="warning" class="icon"></ion-icon>
                  <span class="text">{{'signup.last name' | translate}}</span>
                </div>
              }

              <ion-item
                [ngClass]="signupForm.get('email').touched && signupForm.get('email')?.errors ? 'invalid-field': ''">
                <ion-input placeholder="{{'signup.Email' | translate}}" class="signupfield" formControlName="email"
                type="email" aria-labelledby="ion-input-2-lbl" (input)="autoFill($event,'email')"></ion-input>
              </ion-item>

              @if (signupForm.get('email').touched && signupForm.get('email')?.errors?.pattern) {
                <div class="errorContainer"
                  >
                  <ion-icon name="warning" class="icon"></ion-icon>
                  <span class="text">{{'signup.valid email' | translate}}</span>
                </div>
              }
              @if (signupForm.get('email').touched && signupForm.get('email')?.errors?.required) {
                <div class="errorContainer"
                  >
                  <ion-icon name="warning" class="icon"></ion-icon>
                  <span class="text">{{'signup.enter email' | translate}}</span>
                </div>
              }
              <!-- Confirm email -->
              <ion-item
                [ngClass]="signupForm.get('cemail').touched && signupForm.get('cemail')?.errors ? 'invalid-field': ''">
                <ion-input placeholder="{{'signup.confirm_your_email' | translate}}" class="signupfield"
                  formControlName="cemail" type="email" aria-labelledby="ion-input-2-lbl"
                (input)="autoFill($event,'cemail')" autocomplete="on"></ion-input>
              </ion-item>

              @if (signupForm.get('cemail').touched && signupForm.get('cemail')?.errors?.pattern) {
                <div class="errorContainer"
                  >
                  <ion-icon name="warning" class="icon"></ion-icon>
                  <span class="text">{{'signup.valid email' | translate}}</span>
                </div>
              }
              @if (signupForm.get('cemail').touched && signupForm.get('cemail')?.errors?.required) {
                <div class="errorContainer"
                  >
                  <ion-icon name="warning" class="icon"></ion-icon>
                  <span class="text">{{'signup.enter_confirm_email' | translate}}</span>
                </div>
              }
              @if (signupForm.get('cemail').touched && !signupForm.get('cemail')?.errors?.pattern && !signupForm.get('cemail')?.errors?.required && signupForm?.errors?.match_error) {
                <div class="errorContainer two-line-error-message"
                  >
                  <ion-icon name="warning" class="icon"></ion-icon>
                  <span class="text">{{'signup.match_email_error' | translate}}</span>
                </div>
              }
              <!-- DOB -->
            <ion-item [ngClass]="
              signupForm.get('dateOfBirth').touched && signupForm.get('dateOfBirth')?.errors
                  ? 'invalid-field'
                  : ''
              ">
                <ion-input (pointerdown)="openDateModal($event)" [placeholder]="'your-details.chooseDate' | translate" class="signupfield"
                formControlName="dateOfBirth"></ion-input>
              </ion-item>
              <ion-modal [isOpen]="isDateModalOpen" (didDismiss)="closeDateModal()" #popover class="date">
                  <ng-template>
                    <div class="date-picker1">
                      <ion-datetime mode="ios" [preferWheel]="true" (ionChange)="onDateChange($event)" presentation="date"
                        [value]="defaultDateOfBirth" displayFormat="M/D/YYYY" pickerFormat="MMM D YYYY"
                      [locale]="selectedLanguage"></ion-datetime>
                    </div>
                  </ng-template>
                </ion-modal>
              @if (
                signupForm.get('dateOfBirth').touched &&
                signupForm?.get('dateOfBirth')?.errors?.futureInvalidDate
                ) {
                <div class="errorContainer two-line-error-message">
                  <ion-icon name="warning" class="icon"></ion-icon>
                  <span class="text">{{ "signup.valid_age" | translate }}</span>
                </div>
              }
              <!-- DOB -->
              <ion-grid class="ion-no-padding">
                <ion-row>
                  <ion-col size="3.2" class="ion-no-padding">
                    <ion-item lines="none">
                      <ion-input class="signupfield" type="tel" formControlName="dialCode" min="1" maxlength="4" placeholder="+44"
                      (input)="checkInput($event)" (keypress)="numericOnly($event)"></ion-input>
                      <input id="dialCode" type="tel"
                        (countryChange)="onCell1CountryChange($event)" style="display: none;" readonly/>
                      </ion-item>
                    </ion-col>
                    <ion-col size="0.3" class="ion-no-padding"></ion-col>
                    <ion-col size="8.5" class="ion-no-padding">
                      <ion-item [ngClass]="signupForm.get('phoneNumber').invalid && !numberValid ? 'invalid-field': ''"
                        class="country-select" lines="none">
                        <input type="tel" placeholder="{{'signup.Mobile' | translate}}" maxlength="11"
                          (keypress)="numericOnly($event)" accesskey="p" (hasError)="phoneNumberHasError($event)"
                          class="signup-phone-number signupfield" (input)="getPhoneNumber($event)" formControlName="phoneNumber" />
                        </ion-item>
                      </ion-col>
                    </ion-row>
                  </ion-grid>
                  @if (signupForm.get('phoneNumber')?.errors?.incorrectPhoneNumber) {
                    <div class="errorContainer">
                      <ion-icon name="warning" class="icon"></ion-icon>
                      @if (phoneInValid) {
                        <span class="text">{{'signup.valid mobile' | translate}}</span>
                      }
                      @if (!phoneInValid) {
                        <span class="text">{{'signup.enter mobile' | translate}}</span>
                      }
                    </div>
                  }

                  <ion-item
                    [ngClass]="signupForm.get('password').touched && signupForm.get('password')?.errors ? 'invalid-field': ''">
                    <ion-input [type]="passwordType" formControlName="password"
                      placeholder="{{'signup.Password' | translate}}" class="signupfield"
                      [ngClass]="(signupForm.get('password').value?.length > 0 && passwordIcon === 'eye-off') ? 'password-spacing': 'password-revealed'"
                    maxlength="20" minlength="6" aria-labelledby="ion-input-3-lbl"></ion-input>
                    @if (passwordIcon === 'eye-off') {
                      <img class="password-reveal-icon" width="35" height="35"
                        src="../../../assets/icon/eye.svg" (click)="hideShowPassword()" alt="eye-on" />
                    }
                    @if (passwordIcon === 'eye') {
                      <img class="password-reveal-icon" width="35" height="35"
                        src="../../../assets/icon/eye-off.svg" (click)="hideShowPassword()" alt="eye-off" />
                    }
                  </ion-item>

                  <div class="errorContainer">
                    <span class="passwordHelp">{{'signup.Pick secure' | translate}} </span>
                  </div>

                  @if (signupForm.get('password').touched && signupForm.get('password')?.errors?.minlength) {
                    <div class="errorContainer"
                      >
                      <ion-icon name="warning" class="icon"></ion-icon>
                      <span class="text">{{'signup.valid password' | translate}}</span>
                    </div>
                  }
                  @if (signupForm.get('password').touched && signupForm.get('password')?.errors?.required) {
                    <div class="errorContainer"
                      >
                      <ion-icon name="warning" class="icon"></ion-icon>
                      <span class="text">{{'signup.enter password' | translate}}</span>
                    </div>
                  }

                  <!-- lang / currency selection code -->
                  <div class="selection-wrapper">
                    <div class="lang-wrapper input-sm">
                      <select #langSelect (change)="onLanguageChange(langSelect.value)" title="Language"
                        [(ngModel)]="selectedLanguage" [ngModelOptions]="{standalone: true}">
                        @for (lang of languageArray; track lang) {
                          <option [value]="lang.language_code">{{ lang.language_name }}
                          </option>
                        }
                      </select>
                    </div>
                    <div class="currency-wrapper input-sm">
                      <select #currencySelect (change)="selectChange(currencySelect.value)" title="Currency"
                        [(ngModel)]="ipBasedUserCurrency" [ngModelOptions]="{standalone: true}">
                        @for (code of currencyArray; track code) {
                          <option [value]="code">
                            {{ code }}
                          </option>
                        }
                      </select>
                    </div>
                  </div>

                  <div class="checkbox-row">
                    <p class="accepttext">
                      {{'signup.Lotto Social' | translate}}
                      <span class="urltext" (click)="showTermsPolicy('terms_and_conditions')">
                      {{'signup.conditions' | translate}}</span>
                      {{'signup.and the' | translate}}
                      <span class="urltext" (click)="showTermsPolicy('privacy_policy')">{{'signup.privacy policy' |
                      translate}}</span>
                    </p>
                  </div>
                </div>
                <!-- sms checkbox -->
                <div class="checkbox-row">
                  <div class="check-box">
                    <ion-checkbox mode="md" color="secondary" formControlName="preference" slot="start" class="signupcheck"
                      aria-label="Agree To Terms" aria-labelledby="ion-cb-0-lbl" type="checkbox">
                    </ion-checkbox>
                  </div>
                  <p class="accepttext">{{'signup.not_get_sms' | translate}}</p>
                </div>
                <!-- sms checkbox -->

                <div aria-hidden="true">
                  <ion-button aria-label="submit" expand="block" class="action-btn-large" type="submit"
                    [disabled]="signupForm.invalid">
                  {{'signup.Sign up' | translate}}</ion-button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </ion-content>
